import type { LinksFunction } from '@remix-run/node'
import { NavLink, Outlet, generatePath } from '@remix-run/react'
import { H4, H5, Hero, Section, Stack } from '~/components-v2'
import { getChangelogEntries } from '~/services/contentful'
import changelog from './changelog.css?url'
import { ChangelogSummary } from '~/types'
import { typedjson, useTypedLoaderData } from 'remix-typedjson'
import { editorialDate } from '~/utils/date'

export const links: LinksFunction = () => [
  { rel: 'stylesheet', href: changelog },
]

export { meta } from '~/utils'
export { ErrorBoundary } from '~/components/error-boundary'

export const loader = async () => {
  const entries = await getChangelogEntries()
  return typedjson({ swiftypeSiteType: 'Changelog', entries })
}

export default function () {
  const { entries } = useTypedLoaderData<typeof loader>()

  return (
    <>
      <Hero title="Changelog" />
      <Section aside={<ChangelogNav entries={entries} />}>
        <Outlet />
      </Section>
    </>
  )
}

const changelogRoute = (slug: string) =>
  generatePath(`/changelog/:slug`, { slug })

const ChangelogNavItem = ({
  date,
  slug,
  isLatest,
  title,
}: ChangelogSummary) => {
  return (
    <NavLink end to={isLatest ? '/changelog' : changelogRoute(slug)}>
      <H5 color="text4" fontSize="xxs">
        {editorialDate(date)}
      </H5>
      <H4 color="text" fontSize="sm" lineHeight={1.5}>
        {title}
      </H4>
    </NavLink>
  )
}

const ChangelogNav = ({ entries }: { entries: ChangelogSummary[] }) => (
  <Stack as="nav" className="changelog-nav" gap={4}>
    {entries.map((entry) => (
      <ChangelogNavItem key={entry.slug} {...entry} />
    ))}
  </Stack>
)
